import { parseJwt, useAuth } from "@dutyon/apis";
import { Container, Text } from "@dutyon/ui-kit";
import { Navigate } from "react-router-dom";

interface RoleGuardProps {
  allowedRoles: string[];
  children: React.ReactNode;
}

export function RoleGuard({ allowedRoles, children }: RoleGuardProps) {
  const { token } = useAuth();
  const user = token ? parseJwt(token) : null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return (
      <Container p="xl">
        <Text c="red" fw={500}>
          접근 권한이 없습니다.
        </Text>
        <Text c="dimmed" size="sm" mt="xs">
          이 페이지는 병원 관리자만 접근할 수 있습니다.
        </Text>
      </Container>
    );
  }

  return <>{children}</>;
}
